// extracted by mini-css-extract-plugin
module.exports = {"SwitchToggle":"toggleswitch_SwitchToggle__3HCvp","SwitchToggle_On":"toggleswitch_SwitchToggle_On__38i9L"};